
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import { Helmet } from "react-helmet";

function CozyCottage() {
  const images = [
    {
      original: require("../assets/images/CC/cc-1.jpg"),
      thumbnail: require("../assets/images/CC/cc-1-thumb.jpg"),
    },
    {
      original: require("../assets/images/CC/cc-2.jpg"),
      thumbnail: require("../assets/images/CC/cc-2-thumb.jpg"),
    },
    {
      original: require("../assets/images/CC/cc-3.jpg"),
      thumbnail: require("../assets/images/CC/cc-3-thumb.jpg"),
    },
  ];
  return (
    <div>
      <Helmet>
        <title>Cozy Cottage – A Relaxing 2.5D Adventure Game for Tranquility</title>
        <meta
            name="description"
            content="Cozy Cottage is a peaceful 2.5D adventure game designed for relaxation. Enjoy soothing music, warm fires, and a stress-free escape"
        />
        <meta
          name="keywords"
          content="Cozy adventure game, Relaxing 2.5D game, Cozy game aesthetic, Atmospheric adventure, Tranquil exploration game, Unity, Games, Quiet, Village"
        />
      </Helmet>
      <header>
        <h2>Cozy Cottage</h2>
      </header>
      <div>
      <p>
       Cozy Cottage is a 2.5D adventure game designed to immerse you in pure relaxation. Savor the gentle rustling of the wind, the warm crackle of the fire, and the soothing melodies of soft music as you unwind in a serene, atmospheric world. Let the charm of Cozy Cottage guide you on a peaceful journey down the road to tranquility.
      </p>
      < hr />
      <div className="show-case">
         <ImageGallery items={images} />
      </div>
      < hr />
      <div>
        <p align="center">
          <iframe frameBorder="0" src="https://itch.io/embed/3132378?dark=true" width="552" height="167"><a href="https://xxchester.itch.io/cozy-cottage">Cozy Cottage</a></iframe>
        </p>
      </div>
      </div>
    </div>
  );
}

export default CozyCottage;
